module.exports = __webpack_public_path__ + "img/0Q3A5610_L_Black_MockedUp.1529a6d9.jpg";